import { useState } from 'react'

import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { GOOGLE_MAP_API_KEY } from '@/utils/config'

const GOOGLE_GEOCODE_PATH = `https://maps.googleapis.com/maps/api/geocode/json?latlng=
                              {lat},{lng}&key=${GOOGLE_MAP_API_KEY}`

export const useGeoAddress = ({ lat, lng }) => {
  const [error, setError] = useState(false)

  const { data, isLoading } = useQuery({
    queryKey: ['get-geo-address', lat, lng],
    queryFn: async () => {
      setError(false)
      if (!lat || !lng) {
        setError(true)
        return false
      }
      try {
        const response = await axios.get(
          GOOGLE_GEOCODE_PATH.replace('{lat}', lat).replace('{lng}', lng),
        )
        return response.data?.results?.[0].formatted_address
      } catch (e) {
        setError(false)
        return false
      }
    },
    staleTime: Infinity,
  })
  return { address: data, loading: isLoading, error }
}

export default useGeoAddress
